<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p30"><span><a href="#/Contents#rp30">GARLIC AND SWEET PEPPER SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="49" src="images/45ref.jpg" width="25"/></span></p>
<p class="normal"><span><i>A heart-healthy soup you’re sure to enjoy!</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>½ cup chopped onion</span></p>
<p class="hang"><span>6 cloves garlic, chopped</span></p>
<p class="hang"><span>2 teaspoons olive oil</span></p>
<p class="hang"><span>1 cup each: cubed peeled uncooked potato, chopped red bell pepper</span></p>
<p class="hang"><span>3½ cups reduced-sodium fat-free chicken broth</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="hang"><span>6 tablespoons reduced-fat sour cream</span></p>
<p class="hang"><span>Chopped parsley, as garnish</span></p>
<p class="normalt"><span><a id="page_24"></a><b>1.</b> Sauté onion and garlic in oil in medium saucepan until tender, about 3 minutes. Add potato, bell pepper, and broth. Heat to boiling; reduce heat and simmer, covered, until potato is tender, about 15 minutes. Process soup in food processor or blender until smooth; season to taste with salt and pepper. Refrigerate until cold; top each serving with a dollop of sour cream and sprinkle with parsley.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 107</span></p>
<p class="per1"><span>% calories from fat: 25</span></p>
<p class="per1"><span>Protein (g): 6</span></p>
<p class="per1"><span>Carbohydrate (g): 14.1</span></p>
<p class="per1"><span>Fat (g): 2.9</span></p>
<p class="per1"><span>Saturated fat (g): 1.2</span></p>
<p class="per1"><span>Cholesterol (mg): 5</span></p>
<p class="per1"><span>Sodium (mg): 113</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 1.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0212.vue?5f13fb8d